import Vue from 'vue';

export function setCountry(state, value) {
  state.countrySelected = value;
}
